var render = function render(){var _vm=this,_c=_vm._self._c;return _c('menu_items',{attrs:{"menu_items":_vm.menu_items,"initial_item":"explosives"}})
}
var staticRenderFns = []

export { render, staticRenderFns }